/**
 * Extract the entity key from a QueryKey.
 *
 * @param queryKey QueryKey
 * @returns EntityType
 *
 * getEntityKey(['statuses', 'detail', 123])
 * # => 'statuses'
 */function getEntityKey(queryKey){return queryKey[0];}export{getEntityKey};